<template>
  <div>
    <el-card class="box-card" body-style="min-height:84vh;">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="190px" size="small" class="demo-ruleForm">
        <el-form-item label="拉新启用：" prop="userInviteStatus">
          <el-radio-group v-model="ruleForm.userInviteStatus">
            <el-radio :label="1">开启</el-radio>
            <el-radio :label="0">关闭</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="拉新返佣比例：" prop="firstRechargeCommissionRate">
          <el-input style="width: 424px;" v-model="ruleForm.firstRechargeCommissionRate" placeholder="请输入拉新返佣比例（%）"></el-input>
        </el-form-item>
        <el-form-item label="背景图：" prop="userInviteBackgroundImg">
          <el-upload
            :action="baseUrl+'/system/common/upload/uploadFile'"
            list-type="picture-card"
            :headers="{'Authorization': token}"
            :multiple="false"
            :limit="1"
            :file-list="fileList"
            :on-remove="delImgBtn.bind(null,{'type':1})"
            :on-success="uploadImgBtn.bind(null,{'type':1})">
            <i class="el-icon-plus"></i>
            <div slot="tip" class="el-upload__tip">建议尺寸：750*589px，最多一张，若需要更换图片，请先删除原图片</div>
          </el-upload>
        </el-form-item>
        <el-form-item label="活动图：" prop="userInviteBackgroundImg">
          <el-upload
            :action="baseUrl+'/system/common/upload/uploadFile'"
            list-type="picture-card"
            :headers="{'Authorization': token}"
            :multiple="false"
            :limit="1"
            :file-list="inviteImgList"
            :on-remove="delImgBtn.bind(null,{'type':2})"
            :on-success="uploadImgBtn.bind(null,{'type':2})">
            <i class="el-icon-plus"></i>
            <div slot="tip" class="el-upload__tip">建议尺寸：750*642px，最多一张，若需要更换图片，请先删除原图片</div>
          </el-upload>
        </el-form-item>
        <el-form-item label="拉新规则说明：" prop="userInviteRule">
          <editor :value="ruleForm.userInviteRule" :height="350" v-model="ruleForm.userInviteRule"></editor>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="medium" @click="saveBtn" v-loading.fullscreen.lock="fullscreenLoading">保存</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { fetchUserInviteConfigDetail, saveOrUpdateUserInviteConfig } from '@/api/lx'
import Editor from '@/components/Editor.vue'
export default {
  name: 'LxConfig',
  components: {
    Editor
  },
  data () {
    return {
      imgServer: this.$imgServer,
      baseUrl: this.$baseUrl,
      token:this.$token,
      fullscreenLoading: false,
      fileList:[],
      inviteImgList:[],
      ruleForm: {
        userInviteStatus:'',
        firstRechargeCommissionRate:'',
        userInviteBackgroundImg:'',
        inviteImg:'',
        userInviteRule:''
      },
      rules: {
        userInviteStatus: [
          { required: true, message: '请选择是否开启拉新', trigger: 'blur' }
        ],
        firstRechargeCommissionRate: [
          { required: true, message: '请输入拉新返佣比例（%）', trigger: 'blur' }
        ],
        userInviteBackgroundImg: [
          { required: true, message: '请上传背景图', trigger: 'blur' }
        ],
        inviteImg: [
          { required: true, message: '请上传活动图', trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    let token = sessionStorage.getItem('token')
    if (!token) {
      token = ''
    }
    this.token = token;
    var that = this;
    fetchUserInviteConfigDetail({}).then((res) => {
        if (res.errorCode === '0000') {
          var data = res.data;
          if(data.userInviteBackgroundImg != null){
            that.fileList.push({url: data.userInviteBackgroundImg})
          }
          if(data.inviteImg != null){
            that.inviteImgList.push({url: data.inviteImg})
          }
          that.ruleForm = data;
        }
    })
  },
  methods: {
    uploadImgBtn (obj, file) {
      var type = obj.type;
      var that = this;
      switch (type) {
        case 1:
          // 背景图
          that.ruleForm.userInviteBackgroundImg = file.data.fileUrl
          break;
        case 2:
          // 活动图
          that.ruleForm.inviteImg = file.data.fileUrl
          break;
      }
    },
    /* 删除上传的图片 */
    delImgBtn(obj, file,fileList){
      var type = obj.type;
      var that = this;
      switch (type) {
        case 1:
          // 背景图
          var imgUrl = '';
          fileList.forEach(function(item){
            imgUrl = item.url;
          });
          that.ruleForm.userInviteBackgroundImg = imgUrl;
          break;
        case 2:
          // 活动图
          var imgUrl = '';
          fileList.forEach(function(item){
            imgUrl = item.url;
          });
          that.ruleForm.inviteImg = imgUrl;
          break;
      }
    },
    // 保存操作
    saveBtn () {
      let that = this
      let ruleForm = that.ruleForm
      if(ruleForm.userInviteStatus === ''){
        this.$message.error('请选择是否开启拉新')
        return false
      }
      if(ruleForm.firstRechargeCommissionRate == ''){
        this.$message.error('请输入拉新返佣比例（%）')
        return false
      }
      if(ruleForm.userInviteBackgroundImg == ''){
        this.$message.error('请上传背景图')
        return false
      }
      if(ruleForm.inviteImg == ''){
        this.$message.error('请上传活动图')
        return false
      }
      that.fullscreenLoading = true
      saveOrUpdateUserInviteConfig(ruleForm).then((res) => {
        that.fullscreenLoading = false
        if (res.errorCode === '0000') {
          this.$message({
            message: res.msg,
            type: 'success',
            onClose () {
              that.$router.go(0)
            }
          })
        }
        if (res.errorCode === '1001') {
          this.$message.error(res.msg)
        }
      })
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/market/lx/Config.vue